const DebugLogger = require('./DebugLogger');
const ApiToken = require('./ApiToken');
const Http = require('../custom_components/js/http');
const {UriBuilder} = require('uribuilder');

function getAclPermission(resource) {
    return new Promise((resolve, reject) => {
        const uri = UriBuilder.parse(sessionStorage.getItem(STORAGE_KEY.API_URL));
        uri.pathSegments = [...uri.pathSegments, 'acl']
        const data = [{
            resource,
            action: 'show'
        }];

        uri.query = {
            collection: JSON.stringify(data)
        };

        Http.get(uri.toString()).then((aclResponse) => {
            resolve(aclResponse[0].allow);
        }, (error) => {
            reject(error);
        });
    });
}

module.exports = /* @ngInject */ function ($provide, $httpProvider, $mdDateLocaleProvider, translationServiceProvider, aclServiceProvider, userServiceProvider, sseServiceProvider) {

    const documentLocation = sessionStorage.getItem(STORAGE_KEY.DOCUMENT_LOCATION);
    const apiUrl = sessionStorage.getItem(STORAGE_KEY.API_URL);
    const apiProtocol = sessionStorage.getItem(STORAGE_KEY.API_PROTOCOL);
    const apiHost = sessionStorage.getItem(STORAGE_KEY.API_HOST);
    const eprocFeUrl = sessionStorage.getItem(STORAGE_KEY.EPROC_FE_URL);
    const accessToken = sessionStorage.getItem(STORAGE_KEY.TOKEN);
    const tokenCreationTime = +sessionStorage.getItem(STORAGE_KEY.EPROC_API_CREATION_TIME);
    const tokenExpiresIn = +sessionStorage.getItem(STORAGE_KEY.EPROC_API_EXPIRES_IN);
    const userType = sessionStorage.getItem(STORAGE_KEY.USER_TYPE);

    const fileOrigin = `${window.location.origin}/${documentLocation}`;

    if(userType === 'client') {
        sseServiceProvider.connect(apiUrl, accessToken);
    }

    $provide.factory('apiConfig', /* @ngInject */ function ($q) {

        // current api url without client credentials
        this.apiUrl = apiUrl;

        // set the given expires_in time in seconds
        this.setAccessTokenExpiresIn = function (expiresIn) {
            this.accessTokenExpiresIn = expiresIn;
        };

        /**
         * Returns the baseUrl with given path segments already attached
         * @param pathSegments {any}[]
         * @return {UriBuilder}
         */
        this.getBase = (...pathSegments) => {
            const uri = UriBuilder.parse(apiUrl);
            uri.pathSegments = [...uri.pathSegments, ...pathSegments.map(s => s.toString())];
            return uri;
        }

        // set the given access_token
        this.setAccessToken = function (token) {
            // store the token
            this.accessToken = token;

            // add the bearer Token to each request
            $httpProvider.defaults.headers.common["Authorization"] = 'Bearer ' + this.accessToken;
        };

        // set new access token data by object
        this.refreshAccessToken = function (data) {
            this.setAccessTokenExpiresIn(data.expires_in);
            this.setAccessToken(data.access_token);
        };

        // get the apiConfig object
        this.$get = function () {
            return this;
        };

        // set access token on startup
        this.refreshAccessToken({
            expires_in: tokenCreationTime + tokenExpiresIn - moment().unix(),
            access_token: accessToken
        });

        return this;
    });

    setAclInformation();

    /**
     * Requests the translation file for the given locale and sets it inside the translationService
     **/
    function setLanguage(userLang) {
        $.ajax({
            url: fileOrigin + '/locale/' + userLang + '.json',
            type: 'GET',
            success: function (language) {
                translationServiceProvider.changeLanguage(language, userLang);
            }
        });
    }

    /**
     * Initially sets needed acl information regarding the user and its company
     * */
    function setAclInformation() {
        const USER_TYPES = {
            ADMIN: 'ADMIN',
            CUSTOMER: 'CUSTOMER',
            SUPPLIER: 'SUPPLIER',
        };

        getUser().then((user) => {
            userServiceProvider.setMyself(user);
            setUserLang(user)
            switch (user.type) {
                case USER_TYPES.CUSTOMER:
                    getCustomerCompany().then(company => {

                        aclServiceProvider.setAclUserInformation(user, company.login);
                    });
                    break;
                case USER_TYPES.SUPPLIER:
                    getSupplierCompany().then(company => {
                        aclServiceProvider.setAclUserInformation(user, company.tenantName);
                    });
                    break;
                case USER_TYPES.ADMIN:
                    aclServiceProvider.setAclUserInformation(user);
                    break;
                default:
                    break;
            }
        })
    }

    function setUserLang(user) {
        if (user && user.language && user.language.locale) {
            let userLang = user.language.locale;
            if (userLang.includes('.utf8')) {
                userLang = userLang.replace('.utf8', '');
            }
            if (!userLang.includes('de_DE')) {
                setLanguage(userLang);
            }
        }
    }

    /**
     * Get logged in User from Eproc-Api
     * */
    async function getUser() {
        // a page built with an expired token gets a renewed one from authCtrl shortly after (EPROC-12347)
        await ApiToken.waitForUsableAccessToken();
        return new Promise((resolve, reject) => {
            const url = `${apiUrl}/myself`;
            Http.get(url).then((user) => {
                setSentryUser(user);
                resolve(user);
            }, (error) => {
                reject(error);
            });
        });
    }

    /**
     * Get the company of the logged in user if the userType is "CUSTOMER"
     * */
    function getCustomerCompany() {
        return new Promise((resolve, reject) => {
            const url = `${apiUrl}/customer/company/myself`;
            Http.get(url).then((company) => {
                if (company) {
                    localStorage.setItem(STORAGE_KEY.EPROC_CUSTOMER_COMPANY, JSON.stringify(company))
                    setSentryUserCompanyData(company.id, company.login, company.name);
                }
                resolve(company);
            }, (error) => {
                reject(error);
            });
        });
    }

    /**
     * Get the company of the logged in user if the userType is "SUPPLIER"
     * */
    function getSupplierCompany() {
        return new Promise((resolve, reject) => {
            const url = `${apiUrl}/company/supplier/myself`;
            Http.get(url).then((company) => {
                if (company) {
                    setSentryUserCompanyData(company.id, company.tenantName, company.companyOfficialName);
                }
                resolve(company);
            }, (error) => {
                reject(error);
            });
        });
    }

    $provide.factory('iframeConfig', /* @ngInject */ function ($q) {

        // Message types
        var MESSAGE_INIT = 'init';
        var MESSAGE_ROUTE_CHANGE = 'routeChange';
        var MESSAGE_ACCESS_TOKEN = 'accessToken';
        var BREADCRUMB_UPDATE = 'breadcrumbUpdate';
        var NAVIGATE_TO_ORDER = 'navigateToOrder';
        var NAVIGATE_TO_MY_ORDER_LIST = 'navigateToMyOrderList';
        var NAVIGATE_TO_MY_ADMIN_ORDER_LIST = 'navigateToMyAdminOrderList';
        var NAVIGATE_TO_RFQ = 'navigateToRfq';
        var NAVIGATE_TO_MY_ADMIN_QUERIES_LIST = 'navigateToMyAdminQueries';
        var NAVIGATE_TO_MY_QUERIES_LIST = 'navigateToMyQueries';
        var MESSAGE_ACCOUNTING_CHANGE = 'accountingChange';
        var MESSAGE_API_BASE = 'apiUrl';
        var MESSAGE_EPROC_BASE = 'eprocBase';
        var MESSAGE_SHOW_NOTIFICATION = 'notification';
        var MESSAGE_NAVIGATION_INSTRUCTION = 'notification-instruction';
        var MESSAGE_NOT_FOUND = '404';

        this.iframeBase = eprocFeUrl

        /**
         * adds listener to document to listen to messages from an iframe and passes the incoming messages
         * to the appropriate handling function
         * */
        this.listenToIframeMessages = function (iframeId) {
            window.onmessage = async function (e) {
                if (isJson(e.data)) {
                    var message = JSON.parse(e.data); // in form of {type: string, data: JSON-string}
                    DebugLogger.info('Iframe Message received', message)
                    switch (message.type) {
                        case MESSAGE_INIT:
                            handleInitMessage(message, iframeId);
                            break;
                        case MESSAGE_ACCESS_TOKEN:
                            handleAccessTokenMessage(message, iframeId);
                            break;
                        case MESSAGE_ROUTE_CHANGE:
                            handleRouteChangeMessage(message, iframeId);
                            break;
                        case MESSAGE_API_BASE:
                            handleGetApiBaseMessage(message, iframeId);
                            break;
                        case MESSAGE_EPROC_BASE:
                            handleGetEprocBaseMessage(message, iframeId);
                            break;
                        case BREADCRUMB_UPDATE:
                            // Ignoriere Breadcrumb-Updates für orderReceiptCreateIframe, 
                            // da diese bereits im alten UI angezeigt werden
                            if (iframeId !== 'orderReceiptCreateIframe') {
                                handleIframeBreadcrumbMessage(message);
                            }
                            break;
                        case MESSAGE_SHOW_NOTIFICATION:
                            handleShowNotification(message);
                            break;
                        case MESSAGE_ACCOUNTING_CHANGE:
                            window.dispatchEvent(new CustomEvent(window.ACCOUNT_ASSIGNMENT_CHANGE_EVENT, {}))
                            break;
                        case NAVIGATE_TO_ORDER: {
                            const orderId = message?.data;
                            if(orderId) {
                                const orderDetailRoute = `client/order/${orderId}/detail`;
                                openContent(`container.htm&BC_TEMPLATE_ID=200400000000&if=${orderDetailRoute}`);
                                window.setIFrameRoute(orderDetailRoute);
                            }
                            break;
                        }
                        case NAVIGATE_TO_MY_ADMIN_ORDER_LIST: {
                            await handleMyAdminOrderNavigation(message);
                            break;
                        }
                        case NAVIGATE_TO_MY_ORDER_LIST: {
                            await handleMyOrderNavigation(message);
                            break;
                        }
                        case NAVIGATE_TO_MY_QUERIES_LIST: {
                            await handleMyQueriesNavigation(message);
                            break;
                        }
                        case NAVIGATE_TO_MY_ADMIN_QUERIES_LIST: {
                            await handleMyAdminQueriesNavigation(message);
                            break;
                        }
                        case NAVIGATE_TO_RFQ: {
                            const rfqId = message?.data;
                            if(rfqId) {
                                openContent(`rfq/my_rfq_show.htm&VS_RFQ_ID=${rfqId}`);
                            }
                            break;
                        }
                        default:
                            handleMessageNotRecognized(message, iframeId);
                            break;
                    }
                }
            };
        };

        this.stopListeningToIframeMessages = function() {
            window.onmessage = null;
        }

        this.navigateTo = function(route, iframeId) {
            sendMesageToIframe(MESSAGE_NAVIGATION_INSTRUCTION, route, iframeId);
        }

        /**
         * sends a message to an iframe with given id
         * */
        function sendMesageToIframe(type, message, iframeId) {
            const messageObj = {
                type: type,
                data: message
            };
            document.getElementById(iframeId).contentWindow.postMessage(JSON.stringify(messageObj), '*');
        }

        function handleMyQueriesNavigation(message) {
            const type = message?.data.type;
            const types = {
                OPEN_REQUESTS: 'OPEN_REQUESTS',
                OFFER_ISSUE_DECLINED: 'OFFER_ISSUE_DECLINED',
                OFFERS: 'OFFERS',
                REQUEST_REJECTED: 'REQUEST_REJECTED',
                REQUEST_TO_BE_REWORKED: 'REQUEST_TO_BE_REWORKED',
            }

            let path = [];

            switch (type) {
                case types.OPEN_REQUESTS:
                    path = ['rfq/rfq_main.htm', 'x='];
                    break;
                case types.OFFER_ISSUE_DECLINED:
                    path = ['rfq/rfq_main.htm', 'x=151'];
                    break;
                case types.OFFERS:
                    path = ['rfq/rfq_main.htm', 'x=z'];
                    break;
                case types.REQUEST_REJECTED:
                    path = ['rfq/rfq_main.htm', 'x=14'];
                    break;
                case types.REQUEST_TO_BE_REWORKED:
                    path = ['rfq/rfq_main.htm', 'x=60'];
                    break;
                default:
                    break;
            }

            if(path.length > 0 ) {
                openContent(path.join('&'));
            }
        }

        async function handleMyAdminQueriesNavigation(message) {
            const type = message?.data.type;
            const types = {
                REQUESTS_PENDING_APPROVAL: 'REQUESTS_PENDING_APPROVAL',
                REQUESTS_PENDING_REWORK: 'REQUESTS_PENDING_REWORK',
                OVERDUE_OFFER_ISSUES: 'OVERDUE_OFFER_ISSUES',
                OFFERS_PENDING_APPROVAL: 'OFFERS_PENDING_APPROVAL',
                DECLINED_OFFER_ISSUES: 'DECLINED_OFFER_ISSUES',
                EXPIRED_OFFERS: 'EXPIRED_OFFERS',
            }

            let path = [];

            const aclResource = 'my_adm/request/request_list.htm';
            const hasAclPermission = await getAclPermission(aclResource);

            if(hasAclPermission) {
                switch (type) {
                    case types.REQUESTS_PENDING_APPROVAL:
                        path = [aclResource, 'x=6'];
                        break;
                    case types.REQUESTS_PENDING_REWORK:
                        path = [aclResource, 'x=60', 'bFromDashboard=1'];
                        break;
                    case types.OVERDUE_OFFER_ISSUES:
                        path = [aclResource, 'rfq_overdue=YES', 'bFromDashboard=1'];
                        break;
                    case types.OFFERS_PENDING_APPROVAL:
                        path = [aclResource, 'x=16', 'bFromDashboard=1'];
                        break;
                    case types.DECLINED_OFFER_ISSUES:
                        path = [aclResource, 'x=151', 'bFromDashboard=1'];
                        break;
                    case types.EXPIRED_OFFERS:
                        path = [aclResource, 'offer_overdue=YES', 'bFromDashboard=1'];
                        break;
                    default:
                        break;
                }

                if(path.length > 0 ) {
                    openContent(path.join('&'));
                }
            }
        }

        async function handleMyAdminOrderNavigation(message) {
            const type = message?.data.type;
            const types = {
                ORDER_TO_BE_APPROVED: 'ORDER_TO_BE_APPROVED',
                INCOMING_GOODS_DUE: 'INCOMING_GOODS_DUE',
                INVOICE_TO_BE_APPROVED: 'INVOICE_TO_BE_APPROVED',
                REJECTED_BY_INTERNAL_PROCESSING: 'REJECTED_BY_INTERNAL_PROCESSING',
            }
            let path = [];
            let aclResource = '';

            switch (type) {
                case types.ORDER_TO_BE_APPROVED:
                    aclResource = 'my_adm/release/my_adm_order_free.htm'
                    path = [aclResource];
                    break;
                case types.INCOMING_GOODS_DUE:
                    aclResource = 'my_adm/order/my_adm_order_search.htm'
                    path = [aclResource, 'ACTION=SEARCH', 'x=1', 'VS_DELIVERY_DELAY=0', 'INCLUDE_REMINED=1'];
                    break;
                case types.INVOICE_TO_BE_APPROVED:
                    aclResource = 'my_adm/accounting/invoice_list_release.htm'
                    path = [aclResource, 'invoice_MY_INV_RELEASE=1'];
                    break;
                case types.REJECTED_BY_INTERNAL_PROCESSING:
                    aclResource = 'my_adm/order/my_adm_order_main.htm'
                    path = [aclResource, 'x=25'];
                    break;
                default:
                    break;
            }

            if(path.length > 0 && await getAclPermission(aclResource)) {
                openContent(path.join('&'));
            }
        }

        async function handleMyOrderNavigation(message) {
            const type = message?.data.type;
            const types = {
                RUNNING: 'RUNNING',
                REJECTED: 'REJECTED',
                CANCELLED: 'CANCELLED',
                INVOICE_RELEASE: 'INVOICE_RELEASE',
                REJECTED_INTERNAL_PROCESS: 'REJECTED_INTERNAL_PROCESS',
            }
            let path = [];
            let aclResource = '';

            switch (type) {
                case types.RUNNING:
                    path = ['my_shop/my_order/my_order_list.htm', 'FROM=DASHBOARD', 'my_order_x=running'];
                    break;
                case types.REJECTED:
                    path = ['my_shop/my_order/my_order_list.htm', 'FROM=DASHBOARD', 'my_order_x=3'];
                    break;
                case types.CANCELLED:
                    path = ['my_shop/my_order/my_order_list.htm', 'FROM=DASHBOARD', 'my_order_x=13'];
                    break;
                case types.INVOICE_RELEASE:
                    aclResource = 'my_shop/my_accounting/invoice_list.htm'
                    path = [aclResource, 'invoice_MY_INV_RELEASE=1'];
                    break;
                case types.REJECTED_INTERNAL_PROCESS:
                    path = ['my_shop/my_order/my_order_list.htm', 'FROM=DASHBOARD', 'my_order_x=25'];
                    break;
                default:
                    break;
            }

            if(path.length > 0 && (!aclResource || await getAclPermission(aclResource))) {
                openContent(path.join('&'));
            }
        }

        // language of the logged in user, loaded with the first init message only
        let iframeLanguage;

        /**
         * Handles the initialization message from an iframe and passes the access token and apiUrl.
         * The iframe sends it again to request a renewed token and waits only 10 seconds for a new one,
         * so pass the current token and don't call the API again for the language (EPROC-12347)
         * */
        async function handleInitMessage(message, iframeId) {
            const apiBase = `${apiProtocol}://${apiHost}`;
            await ApiToken.waitForUsableAccessToken();
            if (!iframeLanguage) {
                const user = await getUser();
                iframeLanguage = user.language.iso639LanguageAlpha2;
            }
            const data = {
                accessToken: ApiToken.getAccessToken(),
                apiBase,
                language: iframeLanguage
            };
            sendMesageToIframe(MESSAGE_INIT, JSON.stringify(data), iframeId);
        }

        function handleAccessTokenMessage(message, iframeId) {
            // TODO wenn der iFrame mitteilt, dass z.B. die session abgelaufen ist
        }

        function handleRouteChangeMessage(message, iframeId) {
            const routeOriginal = message.data;
            const routeWithoutQueryParams = routeOriginal.split('?')[0];
            window.setIFrameRoute(routeWithoutQueryParams);
            let breadcrumbs = window.getBreadcrumbs();
            for(const breadcrumb of breadcrumbs) {
                if(breadcrumb.iframeRoute === routeWithoutQueryParams || breadcrumb.iframeRoute === routeOriginal) {
                    const updatedBreadcrumbs = breadcrumbs.slice(0, breadcrumbs.indexOf(breadcrumb) + 1);
                    window.setBreadcrumbs(updatedBreadcrumbs);
                    break;
                }
            }
        }

        function handleGetApiBaseMessage(message, iframeId) {
            var type = MESSAGE_API_BASE;
            var apiBase = `${apiProtocol}://${apiHost}`;
            sendMesageToIframe(type, apiBase, iframeId);
        }

        function handleGetEprocBaseMessage(message, iframeId) {
            var type = MESSAGE_EPROC_BASE;
            var eprocBase = location.protocol + '//' + location.hostname;
            var path = eprocFeUrl.replace(location.hostname, '').replace('/eproc-new/', '');
            eprocBase = eprocBase + path;
            sendMesageToIframe(type, eprocBase, iframeId);
        }

        function handleIframeBreadcrumbMessage(message) {
            const data = JSON.parse(message.data);
            const breadcrumbs = [];
            for(const breadcrumbDto of data) {
                if(!breadcrumbDto.url.includes(':')) {
                    const breadcrumb = new Breadcrumb(breadcrumbDto.label, '', 'container.htm', breadcrumbDto.url, []);
                    breadcrumbs.push(breadcrumb);
                }
            }

            setIframeBreadcrumbs(breadcrumbs);
        }

        function handleMessageNotRecognized(message, iframeId) {
            sendMesageToIframe(MESSAGE_NOT_FOUND, 'Message type not recognized', iframeId);
        }

        function handleShowNotification(message) {
            growl(message.data.translatedMessage, message.data.type, undefined, message.data.timeout);
        }

        /**
         * tests a string if its in JSON format
         * @param str - input string which shall be tested
         */
        function isJson(str) {
            if (typeof str === 'string') {
                return /^[\],:{}\s]*$/.test(
                    str.replace(/\\["\\\/bfnrtu]/g, '@').replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, ']').replace(/(?:^|:|,)(?:\s*\[)+/g, ''));
            }

            return false;
        }

        return this;
    });

    //// Angular Material Datepicker options
    $mdDateLocaleProvider.firstDayOfWeek = 1; // Change week display to start on Monday.
    $mdDateLocaleProvider.formatDate = function (date) {
        if (!date) {
            return '';
        } else {
            return moment(date).format('DD.MM.YYYY');
        }
    };
    $mdDateLocaleProvider.parseDate = function (dateString) {
        var m = moment(dateString, 'L', true);
        return m.isValid() ? m.toDate() : new Date(NaN);
    };
}
